<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from 'echarts'
import resize from './mixins/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '350px',
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, null, {
        renderer: 'canvas',
        useDirtyRect: false,
      })
      this.setOptions(this.chartData)
    },
    setOptions({ expectedData, actualData } = {}) {
      var option

      option = {
        title: {
          text: '每月出團人數',
          textStyle: {
            fontSize: 18,
            fontWeight: 'bolder',
          },
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['去年', '今年'],
          y: 'bottom',
        },
        // grid: {
        //   left: "3%",
        //   right: "4%",
        //   bottom: "3%",
        //   containLabel: true,
        // },
        grid: {
          left: 0,
          right: 15,
          bottom: 25,
          top: 40,
          containLabel: true,
        },
        toolbox: {
          show: false,
          feature: {
            saveAsImage: { show: true },
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月',
          ],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: '去年',
            type: 'line',
            // stack: "Total",
            data: expectedData,
            color: ['#2F5CFF'],
          },
          {
            name: '今年',
            type: 'line',
            // stack: "Total",
            data: actualData,
            color: ['#FFC107'],
          },
        ],
      }

      if (option && typeof option === 'object') {
        this.chart.setOption(option)
      }

      window.addEventListener('resize', this.chart.resize)
    },
  },
}
</script>
